module["exports"] = [
  "GmbH",
  "AG",
  "Gruppe",
  "KG",
  "GmbH & Co. KG",
  "UG",
  "OHG"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de/company/suffix.js
// module id = 776
// module chunks = 0